import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private history: string[] = [];

    constructor(private router: Router) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.history.push(event.urlAfterRedirects);
        });
    }

    back(): void {
        this.history.pop(); // Remove current URL
        if (this.history.length > 0) {
            const previousUrl = this.history[this.history.length - 1];
            this.router.navigateByUrl(previousUrl);
        } else {
            this.router.navigateByUrl('/'); // Fallback to home
        }
    }

    getPreviousUrl(): string | null {
        return this.history.length > 1 ? this.history[this.history.length - 2] : null;
    }
}